
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        value: {
            type: [Object, null, Number, String] as PropType<any>,
            required: true,
        },
        name: {
            type: String,
            default: 'RadioGroup',
        },
        options: {
            type: Array as PropType<any>,
            default: () => [],
        },
        label: {
            type: String,
            default: 'name',
        },
        selectBy: {
            type: String,
            default: 'id',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        red: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const emitUpdate = (option: any) => {
            if (props.disabled) return

            emit('update:value', option[props.selectBy])
            emit('change', option[props.selectBy])
        }

        return { emitUpdate }
    },
})
